import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serchSelect, serchSelectManage, tabulation } from "@/mixins/index";
import { getLinksList, deleLinksList } from "@/api/dataAll/links";
import addLinks from "./components/addLinks";
export default {
  name: "detectLinks",
  components: {
    addLinks: addLinks
  },
  mixins: [serchSelect, serchSelectManage, tabulation],
  data: function data() {
    return {
      advanced: true,
      minWidth: 200,
      tableTitle: [],
      advchannels: [],
      advLocation: [],
      gameId: "",
      value1: "",
      value2: [],
      total: 0,
      pagrSize: 10,
      disabled: true,
      sels: [],
      selsString: '',
      addWayConfig: false,
      searchData: {
        page_size: 10,
        op_ad_channel: '',
        kind: 1,
        page: 1
      },
      showing: false,
      opAdChannel: [{
        label: this.$t('adPlatformJuliang'),
        value: 'jl'
      }, {
        label: this.$t('adPlatformGuangdiantong'),
        value: 'gdt'
      }],
      tableData: [],
      tableLtv: [],
      tableDate: "",
      show: false,
      echarts: false,
      dates: [],
      new_device_num: [],
      new_account_num: [],
      active_account_num: [],
      day_account: [],
      recharge_account_num: [],
      recharge_account_amount: [],
      pay_account_percent: [],
      pay_account_arpu: [],
      pay_account_arppu: [],
      login_account_num: [],
      InitializeOrNot: false
    };
  },
  created: function created() {},
  activated: function activated() {
    if (this.tableData.length) {
      this.searchClick();
    }
  },
  methods: {
    searchClick: function searchClick(e) {
      var _this = this;

      if (!this.searchData.special_product_id.toString()) {
        this.$Message.error(this.$t('selectProduct'));
        return;
      }

      this.searchData.page = e;
      this.reqLoading = true;
      getLinksList(this.searchData).then(function (res) {
        if (res.status == 200) {
          if (!res.data.data.length && _this.searchData.page > 1) {
            _this.searchClick(e - 1);
          } else {
            var list = ['game', 'platform', 'channel', 'pkg', 'ad_channel', 'ad_placement'];
            _this.tableData = res.data.data.length ? _this.$utils.dataConversion(res.data.data, list) : [];
            _this.total = res.data.total - 0 || 0;
          }
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this2 = this;

      this.sels = [];
      val.forEach(function (e) {
        _this2.sels.push(e.id);
      });
      this.selsString = this.sels.toString();
    },
    handleSource: function handleSource(id) {
      this.$refs.addWayConfig.init(id);
    },
    handleClipboard: function handleClipboard(text, event) {
      var _this3 = this;

      this.$copyText(text).then(function (e) {
        _this3.$Message.success(_this3.$t('copySuccess'));
      }, function (e) {
        this.$Message.success(this.$t('copyFailed'));
      });
    },
    changeShow: function changeShow(val) {
      this.showing = val;
    },
    deleAll: function deleAll() {
      var _this4 = this;

      this.$confirm(this.$t('confirmDeleteMonitorLink'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                deleLinksList({
                  id: _this4.selsString
                }).then(function (res) {
                  if (res.status == 200) {
                    _this4.$message({
                      type: "success",
                      message: _this4.$t('deleteSuccessExclamation')
                    });

                    _this4.searchClick(_this4.searchData.page);
                  }
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    },
    handleDelete: function handleDelete(id) {
      var _this5 = this;

      this.$confirm(this.$t('confirmDeleteMonitorLink'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                deleLinksList({
                  id: id
                }).then(function (res) {
                  _this5.searchClick();
                });

                _this5.$message({
                  type: "success",
                  message: _this5.$t('deleteSuccessExclamation')
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    }
  }
};